// extracted by mini-css-extract-plugin
export var labelWrapper = "_bs-0";